module.exports = vendor_c49baa55927a0c05c1b9;